import { useEffect, useState } from 'react';

/**
 * An object URL for a blob, revoked when the blob changes or the component
 * goes away. Each caller makes its own URL, so two views of one cached blob
 * never revoke each other's, and a URL is only returned for the blob it was
 * made from, so switching blobs never shows the previous one for a render.
 */
export function useObjectUrl(blob: Blob | undefined): string | undefined {
  const [entry, setEntry] = useState<{ blob: Blob; url: string }>();

  useEffect(() => {
    if (!blob) {
      setEntry(undefined);
      return;
    }
    const url = URL.createObjectURL(blob);
    setEntry({ blob, url });
    return () => URL.revokeObjectURL(url);
  }, [blob]);

  return entry && entry.blob === blob ? entry.url : undefined;
}
